// removed by extract-text-webpack-plugin
module.exports = {"link":"styles__link__UEFL8","learnMore":"styles__learnMore__3xvzX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/Dropdown/styles.scss
// module id = 397
// module chunks = 0